import React from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { i18n } from "app/i18n/i18n";
import { ShareButton } from "pages/latestResearch/shareMenu/ShareButton";
import { AdvertCard } from "pages/ads/adverts/AdvertCard";
import { PublicationDate, Title, Analysts, Tags, Synopsis } from "./PublicationItems";
import ErrorBoundary from "../../../../lib/ErrorBoundary";
import { NoPublicationsFound } from "../ViewLayout";
import { FileTypeIcon } from "../tileView/PublicationCardParts";

export function ListView({ publications = [] }) {
  const lang = i18n.getLanguage();

  return (
    <ErrorBoundary>
      <ListGroup variant="flush" className="mb-2">
        {publications.map((publication) => {
          const key = publication.id;

          if (!publication.cardType) {
            return <PublicationItem publication={publication} lang={lang} key={key} />;
          }

          if (publication.cardType === "advert") {
            return <AdvertCard key={key} {...publication} />;
          }

          return null;
        })}
        {!publications.length && <NoPublicationsFound />}
      </ListGroup>
    </ErrorBoundary>
  );
}

export function PublicationItem({ publication, lang }) {
  return (
    <ListGroupItem variant="light" className="p-1 py-1">
      <ShareButton publication={publication} />
      <Title {...publication} />
      <Synopsis {...publication} />
      <PublicationDate {...publication} />
      <Analysts lang={lang} {...publication} />
      <Tags lang={lang} {...publication} />
      <FileTypeIcon {...publication} />
    </ListGroupItem>
  );
}
